<template>
  <div>

    <h4>Filter</h4>

    <div class="form-group">
      <label for="period-variant-selector">Period type</label>
      <b-form-select
        id="period-variant-selector"
        v-model="periodVariant"
        :options="periodVariants"
      />
    </div>

    <b-collapse
      v-model="filtrationByPeriod"
    >
      <period-input
        v-model="period"
        class="mb-2"
      />
    </b-collapse>

    <div class="form-group">
      <label for="action">Action</label>
      <!-- TODO: No element with id action. Click on lable do nothig. Fix it. -->

      <resource-game-action-name-fragment-input
        id="action"
        v-model="actionNameFragment"
      />
    </div>

    <div class="form-group">
      <label for="product">Product (example: @item/stock/m3star)</label>
      <!-- TODO: No element with id product. Click on lable do nothig. Fix it. -->

      <proto-item-alias-input
        id="product"
        v-model="productAlias"
      />
    </div>

    <hr>

    <p v-if="message !== null">
      {{message}}
    </p>

    <table v-if="filteredItems !== null && filteredItems.length > 0" class="table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Id</th>
          <th scope="col">Time</th>
          <th scope="col">Action</th>
          <th scope="col">Product</th>
          <th scope="col" class="text-right">Old amount</th>
          <th scope="col" class="text-right">Delta</th>
          <th scope="col" class="text-right">Result</th>
          <th scope="col">Details</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="item in filteredItems">
        <tr :key="item.id">
          <td>{{item.id}}</td>
          <td>{{item.ctime | getMomentStr}}</td>
          <td v-html="highlightedActionName(item.action)"></td>
          <td v-html="highlightedItemProductAlias(item.productAlias)"></td>
          <td class="text-right">{{item.old_amount | getFormattedNumber}}</td>
          <td
            class="text-right"
            :class="getDeltaClass(item.new_amount - item.old_amount)"
          >
            {{item.new_amount - item.old_amount | getFormattedDifference}}
          </td>
          <td class="text-right">{{item.new_amount | getFormattedNumber}}</td>
          <td>
            <span
              v-if="hasDetails(item)"
              v-b-popover.click.left="getDetails(item)"
              class="tooltip-button"
            >
              Details
            </span>
          </td>
        </tr>
        </template>
      </tbody>
    </table>

    <hr>

    <p class="mb-3">
      Количество выполненных уровней по данным находящимся в журнале ресурсов: {{calcLevelsDone}}
    </p>
    <p class="mb-3">
      В журнале ресурсов данные хранятся 7 дней.
      Затем устаревшие данные автоматически удаляются.
      Поэтому здесь показано количество выполненных уровней только за последние 7&nbsp;дней.
    </p>
    <p>
      Если игрок играл дольше 7 дней, то количество уровней пройденных игроком за все время может быть больше,
      чем количество уровней пройденных за&nbsp;последние 7 дней.
    </p>

    <hr>

  </div>
</template>

<script>
import PeriodInput from './PeriodInput.vue';
import ProtoItemAliasInput from './ProtoItemAliasInput.vue';
import ResourceGameActionNameFragmentInput from './ResourceGameActionNameFragmentInput.vue';

import { getEnumResourceGameActionName } from '../autogen/bundle';
import { getDeltaClass } from '../util';
import { getPeriodLast24Hours } from '../util';
import { convertMomentToSec   } from '../util';
import { isStringSpecified    } from '../util';

const PERIOD_ALL       = 1;
const PERIOD_SPECIFIED = 2;

const ACTION_LEVEL_COMPLETE =  5;
const ACTION_BUY_COINS      = 14;

export default {
  name: 'PlayerResourceLogItems',

  components: {
    PeriodInput,
    ResourceGameActionNameFragmentInput,
    ProtoItemAliasInput,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      periodVariant: PERIOD_ALL,
      periodVariants: [
        {value: PERIOD_ALL,       text: 'all time'},
        {value: PERIOD_SPECIFIED, text: 'specified period'},
      ],

      filtrationByPeriod: false,

      period: getPeriodLast24Hours(),
      actionNameFragment: '',
      productAlias: '',
    };
  },

  computed: {
    filteredItems() {
      if(this.items === null) {
        return null;
      }

      if(this.period === null) {
        return null;
      }

      const lowLevelFilter = {
        period: null,

        // Перевод в нижний регистр нужен для регистронезависимого поиска.
        actionNameFragmentLowerCase: this.actionNameFragment.toLowerCase(),

        productAlias: this.productAlias,
      };

      if(this.filtrationByPeriod) {
        lowLevelFilter.period = {
          beginSec: convertMomentToSec(this.period.begin),
          endSec:   convertMomentToSec(this.period.end),
        };
      }

      const fItems = [];
      for(let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        if(canShowItem(lowLevelFilter, item)) {
          fItems.push(item);
        }
      }

      return fItems;
    },

    message() {
      if(this.items !== null && this.items.length === 0) {
        return 'Resource log is empty.';
      }

      if(this.period === null) {
        return 'Period is not valid.';
      }

      if(this.filteredItems !== null && this.filteredItems.length === 0) {
        return 'No matched items.';
      }

      return null;
    },

    calcLevelsDone() {
      const STAR_PROTO_ID = 41259540;

      let levelAmount = 0;
      for(let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        if(item.action === ACTION_LEVEL_COMPLETE && item.proto_id === STAR_PROTO_ID) {
          levelAmount++;
        }
      }

      return levelAmount;
    },
  },

  watch: {
    periodVariant() {
      this.filtrationByPeriod = this.periodVariant === PERIOD_SPECIFIED;
    },
  },

  methods: {
    getDeltaClass,

    hasDetails(item) {
      return item.action === ACTION_BUY_COINS;
    },

    getDetails(item) {
      if(item.action === ACTION_BUY_COINS) {
        return this.getBuyCoinsDetails(item);
      }
      return null;
    },

    getBuyCoinsDetails(item) {
      const orderId = ('orderId' in item) ? item.orderId : '?';
      return 'order id: ' + orderId;
    },

    highlightedActionName(actionId) {
      const actionName = getEnumResourceGameActionName(actionId);

      const actionNameFragment = this.actionNameFragment;
      if(!isStringSpecified(actionNameFragment)) {
        return actionName;
      }

      const re = new RegExp(actionNameFragment, 'gi');
      const formattedStr = actionName.replace(re, `<strong>$&</strong>`);
      return formattedStr;
    },

    highlightedItemProductAlias(itemProductAlias) {
      const filterProductAlias = this.productAlias;
      if(!isStringSpecified(filterProductAlias)) {
        return itemProductAlias;
      }

      const re = new RegExp(filterProductAlias, 'g');
      const formattedStr = itemProductAlias.replace(re, `<strong>$&</strong>`);
      return formattedStr;
    },
  },

  filters: {
    getEnumResourceGameActionName,
  },
};

// If all conditions are met,
// item passes through the filter
function canShowItem(filter, item) {
  const filterPeriod = filter.period;
  if(filterPeriod !== null) {
    if(item.ctime < filterPeriod.beginSec) {
      return false;
    }
    if(item.ctime >= filterPeriod.endSec) {
      return false;
    }
  }

  const filterActionNameFragmentLowerCase = filter.actionNameFragmentLowerCase;
  if(isStringSpecified(filterActionNameFragmentLowerCase)) {
    // регистронезависимый поиск
    const itemActionName = getEnumResourceGameActionName(item.action);
    const itemActionNameLowerCase = itemActionName.toLowerCase();
    if(!itemActionNameLowerCase.includes(filterActionNameFragmentLowerCase)) {
      return false;
    }
  }

  const filterProductAlias = filter.productAlias;
  if(isStringSpecified(filterProductAlias)) {
    const index = item.productAlias.indexOf(filterProductAlias);
    if(index === -1) {
      return false;
    }
  }

  return true;
}

</script>

<style scoped>
  .tooltip-button {
    text-decoration: underline;
    cursor: pointer;
  }
</style>
